import type { FaireProductEntity } from "../../entity_types/product";

export const p_hxbxth7hm2: FaireProductEntity = {
  token: "p_hxbxth7hm2",
  type: "product",
  name: "Colorful Congrats Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/02e7762ec66b7460ffdd1586ed4467435f193b35609f7861b77f33a43aacd9e6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b16319c370a3b894bac8e69ee5c781c67c769b1e227ad7e4a83f78fcc4b074d0.png",
    "https://cdn.faire.com/fastly/f92e3394d2b3d52a104164a9b4db9ab88e8ed506ca7e528727fab87440e35c6b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:02.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
